import { lazy } from 'react';

import type { ModuleWeb } from '../registry.js';

/**
 * Écrans du module Sondages (spec 007) : espace bénévole simplifié (« Mon espace ») et espace
 * gestion (`sondages:gerer`), chargés à la demande ; chaque écran revérifie ses droits côté
 * serveur.
 */
const page = <T extends string>(
  load: () => Promise<Record<T, () => React.ReactElement>>,
  name: T,
) => lazy(() => load().then((m) => ({ default: m[name] })));

const mine = () => import('./MesSondagesPage.js');
const gestion = () => import('./GestionPages.js');
const MesSondagesPage = page(mine, 'MesSondagesPage');
const MonSondagePage = page(mine, 'MonSondagePage');
const SondagesGestionPage = page(gestion, 'SondagesGestionPage');
const SondageEditeurPage = page(gestion, 'SondageEditeurPage');
const SondageDetailPage = page(gestion, 'SondageDetailPage');
const RelancesSondagesPage = page(gestion, 'RelancesSondagesPage');

export const sondagesWeb: ModuleWeb = {
  module: 'sondages',
  routes: [
    { path: '/sondages/mes-sondages', element: <MesSondagesPage /> },
    { path: '/sondages/mes-sondages/:id', element: <MonSondagePage /> },
    { path: '/sondages', element: <SondagesGestionPage /> },
    { path: '/sondages/nouveau', element: <SondageEditeurPage /> },
    { path: '/sondages/gestion/:id', element: <SondageDetailPage /> },
    { path: '/sondages/gestion/:id/modifier', element: <SondageEditeurPage /> },
    { path: '/sondages/relances', element: <RelancesSondagesPage /> },
  ],
};
